import React from "react";
import { UiInfoCard } from "../../components/cards/UiInfoCard";
import { UiGoalsItem } from "../../components/cards/UiInfoCardContent";
import UserImage from '../../../../styles/img/user.jpg'

export const GoalCard = (props) => {

    const TeamImage = [ UserImage,UserImage ,UserImage,UserImage ];

    return (
        <>
            <UiInfoCard
                subtitle="Your Goals"
                linkTitle="Add More Goals"
                LinkTo=""
                footer={true}
            >

                <UiGoalsItem
                    title="Nick’s Personal Weekend Goal"
                    description="Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco."
                    progressVal="75"
                    progressInfo="Buy 250 remaining points for £3.50?"
                />

                <UiGoalsItem
                    title="Nick’s Team Holiday Goal"
                    description="Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco."
                    splitTeam={true}
                    progressVal="25"
                    progressInfo="Buy 750 remaining points for £13.50?"
                    team="Split between You, Jane, Rick & Jessica"
                    images={TeamImage}
                />




            </UiInfoCard>
        </>
    )

}